export interface TabLogEventsOptions {
    enableMinimumDurationFilter: boolean;
}

const defaultTabOptions: TabLogEventsOptions = {
    enableMinimumDurationFilter: true,
};

export { defaultTabOptions };
